export default {
  company: 'Pontio',
  landingPage: 'https://www.gopontio.com/',
  technicalSupportTel: '+34919032923',
  customerServiceTel: '+34919034748',
  supportMail: 'soporte@gopontio.com',
  finalcustomersMail: 'clientes@gopontio.com',
}
